import React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton, Text, Icon, Stack, ContextualMenu } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import DialogConfirmDelete from './DialogConfirmDelete';
import { ProyectoGlosa } from '../../system/proyectos_glosa/ProyectosGlosaSystem';

const subtitleActivity: React.CSSProperties = {
  fontSize: 16,
  marginBottom: 5,
  display: 'flex',
  alignItems: 'center',
};

const iconText: React.CSSProperties = {
  fontSize: 19,
  marginRight: '0.5rem',
  position: 'relative',
  top: 2,
};

interface ProyectosGlosaDetailDialogProps {
  show: boolean;
  item: ProyectoGlosa | null;
  onEdit: (item: ProyectoGlosa) => void;
  onDelete: (item: ProyectoGlosa) => void;
  onClose: () => void;
}

const ProyectosGlosaDetailDialog: React.FC<ProyectosGlosaDetailDialogProps> = (props) => {
  const { t } = useTranslation();
  const { item } = props;
  const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);

  if (!item) return null;

  const handleDeleteClick = () => {
    setShowConfirmDelete(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmDelete(false);
    props.onDelete(item);
  };

  const handleCancelDelete = () => {
    setShowConfirmDelete(false);
  };

  return (
    <Dialog
      hidden={!props.show}
      onDismiss={props.onClose}
      dialogContentProps={{
        type: DialogType.normal,
        title: t('Detalle del proyecto'),
      }}
      modalProps={{
        isBlocking: true,
        dragOptions: {
          moveMenuItemText: 'Move',
          closeMenuItemText: 'Close',
          menu: ContextualMenu,
        },
      }}
      minWidth={480}
    >
      <Stack tokens={{ childrenGap: 8 }} styles={{ root: { padding: '12px 0' } }}>
        <Text block variant="large" style={subtitleActivity}>
          <Icon iconName="Dictionary" style={iconText} />
          {item.dicprog_nombre_proyecto}
        </Text>
        <Text block variant="large" style={subtitleActivity}>
          <Icon iconName="Calendar" style={iconText} />
          {t('Inicio')}: {item.dicprog_fecha_validez_inicio}
        </Text>
        <Text block variant="large" style={subtitleActivity}>
          <Icon iconName="Calendar" style={iconText} />
          {t('Fin')}: {item.dicprog_fecha_validez_fin}
        </Text>
        <Text block variant="large" style={subtitleActivity}>
          {item.dicprog_activo ? (
            <Icon iconName="CheckMark" className="color-success" style={iconText} />
          ) : (
            <Icon iconName="Cancel" className="color-error" style={iconText} />
          )}
          {item.dicprog_activo ? t('Activo') : t('Inactivo')}
        </Text>
      </Stack>
      <DialogConfirmDelete
        isOpen={showConfirmDelete}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        title={t('Eliminar proyecto comercial')}
        message={t('¿Deseas eliminar este proyecto comercial?')}
        confirmText={t('Eliminar')}
        cancelText={t('Cancelar')}
      />
      <DialogFooter>
        <PrimaryButton onClick={() => props.onEdit(item)} text={t('Editar')} />
        <DefaultButton
          onClick={handleDeleteClick}
          text={t('Eliminar')}
          styles={{
            root: { borderColor: '#d13438', color: '#d13438' },
            rootHovered: { borderColor: '#a4262c', color: '#a4262c', backgroundColor: '#fde7e9' },
          }}
        />
        <DefaultButton onClick={props.onClose} text={t('Cerrar')} />
      </DialogFooter>
    </Dialog>
  );
};

export default ProyectosGlosaDetailDialog;
